import { COLOR } from '@src/styles/color';
import BackgroundPromoVoice from '@src/assets/images/background-promo-voice.png';

const variants = {
  'variant-voice-cloning': {
    borderColor: COLOR.borderPromoVoice,
    backgroundImage: BackgroundPromoVoice,
    paddingImage: '11px 18px',
    marginTopContent: '8px',
    padding: '12px 16px',
  },
  'variant-earnings-management': {
    borderColor: COLOR.borderPromoEarnings,
    backgroundColor: COLOR.backgroundPromoEarnings,
    padding: '24px',
  },
};

export default variants;
